import { z } from "zod";

export const brandManifestSchema = z.object({
	brandId: z.string(),
	appName: z.string(),
	slug: z.string(),
	scheme: z.string(),
	bundleId: z.string(),
	packageName: z.string(),
	communityId: z.string(),
	communitySlug: z.string(),
	easProjectId: z.string(),
	ascAppId: z.string().nullable(),
	google: z.object({
		iosClientId: z.string(),
		iosReversedClientId: z.string(),
		androidClientId: z.string(),
		webClientId: z.string(),
	}),
	colors: z.object({
		primary: z.string(),
		secondary: z.string(),
		splash: z.string(),
	}),
	iconUrl: z.string(),
	splashUrl: z.string(),
	adaptiveIconUrl: z.string(),
});

export type BrandManifest = z.infer<typeof brandManifestSchema>;
